/* eslint-disable react/require-default-props */
import { Delete } from '@mui/icons-material';
import { Stack, InputLabel } from '@mui/material';
import { TextField, IconButton } from 'pvs-design-system';
import React from 'react';

interface ParameterTextFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  error: boolean;
  prefix?: string;
  index?: number;
  onDeleteClick?: () => void;
  errorMessage?: string;
  showDeleteIcon?: boolean;
}

const ParameterTextField: React.FC<ParameterTextFieldProps> = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  error,
  prefix = '',
  index = 0,
  onDeleteClick = () => {},
  errorMessage = '',
  showDeleteIcon = true,
}) => {
  return (
    <Stack alignItems="self-end">
      {index > 0 && prefix && (
        <InputLabel htmlFor={id} sx={{ position: 'absolute', left: '-9999px' }}>
          {prefix} Parameter Name {index}
        </InputLabel>
      )}
      <TextField
        id={id}
        label={label}
        InputProps={{
          'aria-label':
            prefix && index !== undefined
              ? `${prefix} Parameter Name ${index + 1}`
              : undefined,
          ...(showDeleteIcon &&
            onDeleteClick && {
              endAdornment: (
                <IconButton
                  id={`${id}-delete-${index ?? 0}`}
                  color="primary"
                  aria-label={`Delete Parameter ${index ?? 0}`}
                  onClick={onDeleteClick}
                  size="small"
                >
                  <Delete />
                </IconButton>
              ),
            }),
        }}
        InputLabelProps={{
          shrink: true,
          ...(prefix &&
            index !== undefined && {
              id: `${prefix} Parameter Name ${index + 1}`,
            }),
        }}
        variant="outlined"
        size="medium"
        fullWidth
        required
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        errorMessage={errorMessage}
      />
    </Stack>
  );
};

export default ParameterTextField;
